/**
 * combineReducers helper function turns an object whose values are different reducing functions into a single reducing function you can pass to createStore
 * We can separate the reducers in parts, where every part has it task, then after we use the combineReducers to join and send to createStore
 */

import { combineReducers } from "redux";

import PartnerAgreementReducer from "../PartnerAgreement/reducer";
//import { PartnerAgreementReducer }   from 'src/modules/PartnerAgreement';
import signatureReducer from "../NTICore/component/Signature/reducer";
//import { signatureReducer }   from 'src/modules/NTICore/component/Signature';
import ErrorReducer from "../ErrorManage/reducer";
//import { ErrorReducer } from 'src/modules/ErrorManage';

import { reducer as FormReducer } from "redux-form";

const reducers = combineReducers({
  // Manage PartnerAgreementReducer
  PartnerAgreementReducer,

  // Manage UtilsReducer Reducer
  ErrorReducer,

  // Include signature to app store
  signatureReducer,

  // Manage Form Reducer
  form: FormReducer,
});

export default reducers;



// WEBPACK FOOTER //
// ./src/modules/Setup/MainReducers.js